import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  Token: sessionStorage.getItem('apiToken'),
  user: null,
  sessionExpired: false,
  tokenExpireTime: null, 
  showRefreshWarning: false,
  refreshTimeoutId: null,
  warningTimeoutId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSessionExpired: (state, action) => {
      state.sessionExpired = action.payload;
    },
    setTokenExpireTime: (state, action) => {
      state.tokenExpireTime = action.payload;
    },
    setShowRefreshWarning: (state, action) => {
      state.showRefreshWarning = action.payload;
    },
    setRefreshTimeoutId: (state, action) => {
      state.refreshTimeoutId = action.payload;
    },
    setWarningTimeoutId: (state, action) => {
      state.warningTimeoutId = action.payload;
    },
    clearTimeouts: (state) => {
      if (state.refreshTimeoutId) {
        clearTimeout(state.refreshTimeoutId);
        state.refreshTimeoutId = null;
      }
      if (state.warningTimeoutId) {
        clearTimeout(state.warningTimeoutId);
        state.warningTimeoutId = null;
      }
    }
  }
});

export const { 
  setSessionExpired,
  setTokenExpireTime, 
  setShowRefreshWarning,
  setRefreshTimeoutId,
  setWarningTimeoutId,
  clearTimeouts  
} = authSlice.actions;

export default authSlice.reducer;
